import Vue from 'vue'
import {
    Message,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    Button,
    Carousel,
    CarouselItem,
    Image,
    Popover,
    Input,
    Table,
    TableColumn,
    Dialog,
    Tree,
    MessageBox,
    Checkbox,
    CheckboxGroup,
    Tooltip,
    Menu,
    Submenu,
    MenuItem,
    MenuItemGroup,
    Loading,
    Card,
    Timeline,
    TimelineItem,
    InfiniteScroll,
    Pagination,
    Select,
    Option,
    Progress
} from 'element-ui'

Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Button)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Image)
Vue.use(Popover)
Vue.use(Input)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Dialog)
Vue.use(Tree)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Tooltip)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(Submenu)
Vue.use(MenuItemGroup)
Vue.use(Card)
Vue.use(Timeline)
Vue.use(TimelineItem)
Vue.use(Pagination)
Vue.use(Select)
Vue.use(Option)
Vue.use(Progress)
Vue.use(Loading)
Vue.use(Loading.directive)
Vue.use(InfiniteScroll)
// Vue.use(InfiniteScroll.directive)

Vue.prototype.$loading = Loading.service
Vue.prototype.$message = Message;
Vue.prototype.$confirm = MessageBox.confirm;
